/**
 * Authentication API Service
 * All auth-related API calls using axios
 */

import apiClient from "./client";

export const authService = {
  /**
   * Login user
   * @param {Object} credentials - { email, password }
   * @returns {Promise} { user, token }
   */
  login: credentials => apiClient.post("/auth/login", credentials),

  /**
   * Register new user
   * @param {Object} userData - User registration data
   * @returns {Promise} { user, token }
   */
  register: userData => apiClient.post("/auth/register", userData),

  /**
   * Logout user
   * @returns {Promise} Success response
   */
  logout: () => apiClient.post("/auth/logout"),

  /**
   * Get current user
   * @returns {Promise} User object
   */
  getCurrentUser: () => apiClient.get("/auth/me"),

  /**
   * Refresh token
   * @returns {Promise} { token }
   */
  refreshToken: () => apiClient.post("/auth/refresh"),

  /**
   * Request password reset
   * @param {string} email - User email
   * @returns {Promise} Success response
   */
  forgotPassword: email => apiClient.post("/auth/forgot-password", { email }),

  /**
   * Reset password
   * @param {Object} data - { token, password }
   * @returns {Promise} Success response
   */
  resetPassword: data => apiClient.post("/auth/reset-password", data),
};
